module.exports = "/subscriptions/assets/10d22c5fe4d79f77ca433443c82043b4.png";